import React from 'react';
import { useFormContext } from 'react-hook-form';
import { PasswordInput } from 'app/components/Core';
import { PasswordPolicyMessage } from 'app/components/Core/PasswordPolicyMessage';
import { PasswordChangeFormData } from 'app/components/Settings/PasswordChangeDialog/utils';
import { PasswordPolicy } from 'types/auth';
import { Box } from '@chakra-ui/react';

interface PasswordChangeFormFieldsProps {
  passwordPolicy?: PasswordPolicy;
}

export const PasswordChangeFormFields: React.FC<PasswordChangeFormFieldsProps> = ({
  passwordPolicy,
}) => {
  const {
    formState: { errors },
    register,
    getValues,
    trigger,
  } = useFormContext<PasswordChangeFormData>();

  return (
    <>
      <PasswordInput
        label="Current Password"
        {...register('currentPassword')}
        isInvalid={Boolean(errors?.currentPassword)}
        errorMessage={errors?.currentPassword?.message}
        data-testid="current-password"
      />
      <PasswordInput
        label="New Password"
        {...register('newPassword', {
          onChange: () => {
            if (getValues('newPasswordRepeat')) {
              trigger('newPasswordRepeat');
            }
          },
        })}
        isInvalid={Boolean(errors?.newPassword)}
        errorMessage={errors?.newPassword?.message}
        data-testid="new-password"
      />
      <Box>
        <PasswordInput
          label="Confirm New Password"
          {...register('newPasswordRepeat')}
          isInvalid={Boolean(errors?.newPasswordRepeat)}
          errorMessage={errors?.newPasswordRepeat?.message}
          data-testid="new-password-confirm"
        />
        <PasswordPolicyMessage
          passwordPolicy={passwordPolicy}
          pt={1}
          pb={0.5}
        />
      </Box>
    </>
  );
};
